<template>
  <Popup
    :title="title"
    :btn-text="buttonText"
    :disabled="isButtonDisabled"
    :loading="loading"
    btn-colored="danger"
    @close="onClose"
    @approve="nextStep"
  >
    <div v-if="step === 1" class="delete-confirm">
      <div class="delete-confirm__info">
        <icon-base icon-name="delete" :width="50" :height="50" />
        <p class="delete-confirm__count">
          {{ selectedText }}
        </p>
        <span class="delete-confirm__hint">
          Выбрано для удаления: {{ selectedCount }}
        </span>
      </div>
    </div>

    <div v-if="step === 2" class="delete-confirm">
      <Alert type="warn">
        <strong>Внимание! Прочитайте это предупреждение!</strong>
      </Alert>
      <div class="delete-confirm__consequences">
        <p>Это действие <strong>необратимо</strong> и приведёт к удалению:</p>
        <ul>
          <li>конфигурации телеметрии выбранных адресов;</li>
          <li>
            настроек счётчиков и данных абонентов всех помещений выбранных
            адресов.
          </li>
        </ul>
        <p class="delete-confirm__consequences-note">
          Восстановление данных после удаления невозможно.
        </p>
      </div>
    </div>

    <div v-if="step === 3" class="delete-confirm">
      <p class="delete-confirm__instruction">
        Для подтверждения введите
        <strong>&laquo;{{ confirmationPhrase }}&raquo;</strong> в поле ниже
      </p>
      <input
        ref="confirmInput"
        v-model="confirmationText"
        class="delete-confirm__input"
        :placeholder="confirmationPhrase"
        autocomplete="off"
        @keyup.enter="onEnterKey"
      />
    </div>
  </Popup>
</template>

<script>
import Popup from '../../components/Popup.vue'
import IconBase from '../../components/Icons/IconBase.vue'
import Alert from '../../components/Alert.vue'

export default {
  name: 'MeterDeleteConfirm',
  components: { Popup, IconBase, Alert },
  emits: ['approve', 'close'],
  props: {
    selectedCount: {
      type: Number,
      default: 1,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      step: 1,
      confirmationText: '',
      confirmationPhrase: 'УДАЛИТЬ',
    }
  },
  computed: {
    title() {
      return 'Удалить телеметрию'
    },
    selectedText() {
      if (this.selectedCount === 1) {
        return '1 телеметрия'
      } else if (this.selectedCount < 5) {
        return `${this.selectedCount} телеметрии`
      } else {
        return `${this.selectedCount} телеметрий`
      }
    },
    buttonText() {
      switch (this.step) {
        case 1:
          return 'Я хочу удалить телеметрию'
        case 2:
          return 'Я прочитал(а) и понимаю последствия'
        case 3:
          return 'Удалить телеметрию'
        default:
          return 'Далее'
      }
    },
    isButtonDisabled() {
      if (this.loading) return true
      if (this.step === 3) {
        return (
          this.confirmationText.trim().toUpperCase() !==
          this.confirmationPhrase.toUpperCase()
        )
      }
      return false
    },
  },
  methods: {
    nextStep() {
      if (this.step < 3) {
        this.step++
        if (this.step === 3) {
          this.$nextTick(() => {
            this.$refs.confirmInput?.focus()
          })
        }
      } else {
        this.$emit('approve')
      }
    },
    onClose() {
      this.step = 1
      this.confirmationText = ''
      this.$emit('close')
    },
    onEnterKey() {
      if (!this.isButtonDisabled) {
        this.nextStep()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.delete-confirm {
  display: flex;
  flex-direction: column;
  gap: 16px;

  &__info {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 20px 0;
    color: $color-red;
  }

  &__count {
    font-size: 20px;
    font-weight: 700;
    color: $color-default;
    margin: 0;
  }

  &__hint {
    font-size: 14px;
    color: $color-grey;
  }

  &__consequences {
    font-size: 14px;
    line-height: 1.6;
    color: $color-default;

    ul {
      margin: 8px 0;
      padding-left: 20px;

      li {
        margin-bottom: 4px;
      }
    }

    &-note {
      margin-top: 8px;
      color: $color-red;
      font-weight: 600;
    }
  }

  &__instruction {
    font-size: 14px;
    color: $color-default;
    margin: 0;
  }

  &__input {
    width: 100%;
    padding: 12px 16px;
    border: 2px solid $color-grey-5;
    border-radius: $border-radius-xs;
    font-size: 16px;
    outline: none;
    transition: border-color 0.2s ease;
    box-sizing: border-box;

    &:focus {
      border-color: $color-red;
    }

    &::placeholder {
      color: $color-grey;
      opacity: 0.5;
    }
  }
}
</style>
